module.exports = __webpack_public_path__ + "assets/2f3d03d32a1231809b59ef43c1f554f2.mp3";